import { Star } from "lucide-react";

export const Stars = ({ value, size = "h-4 w-4", testId }) => (
  <span className="inline-flex gap-0.5" data-testid={testId} aria-label={`${value} out of 5 stars`}>
    {[1, 2, 3, 4, 5].map((i) => (
      <Star key={i} className={`${size} ${i <= Math.round(value) ? "fill-amber-400 text-amber-400" : "text-slate-300"}`} />
    ))}
  </span>
);

export const StarInput = ({ value, onChange, testPrefix }) => (
  <div className="flex gap-1" role="radiogroup" aria-label="Rating">
    {[1, 2, 3, 4, 5].map((i) => (
      <button key={i} type="button" onClick={() => onChange(i)} aria-label={`${i} stars`} data-testid={`${testPrefix}-star-${i}`}
        className="p-1 rounded-md hover:bg-amber-50 transition-transform hover:scale-110">
        <Star className={`h-7 w-7 ${i <= value ? "fill-amber-400 text-amber-400" : "text-slate-300"}`} />
      </button>
    ))}
  </div>
);
